import { render, staticRenderFns } from "./badgeComponent.vue?vue&type=template&id=3ec7bb98&"
import script from "./badgeComponent.vue?vue&type=script&lang=js&"
export * from "./badgeComponent.vue?vue&type=script&lang=js&"
import style0 from "./badgeComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/c/Users/tes028/source/Tesfri/logistic-variant-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ec7bb98')) {
      api.createRecord('3ec7bb98', component.options)
    } else {
      api.reload('3ec7bb98', component.options)
    }
    module.hot.accept("./badgeComponent.vue?vue&type=template&id=3ec7bb98&", function () {
      api.rerender('3ec7bb98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/shared/components/generic/badge/badgeComponent.vue"
export default component.exports